import { isDefined } from './bids';
import { DEFAULT_PAGE_NUM, DEFAULT_PAGE_SIZE, ALL } from 'shared/consts/giftCards';
import { UrlParams, RequestParams } from 'shared/types/giftCards';

export const isParameterAll = (value: string | undefined) => !isDefined(value) || value === ALL;

export const getGiftCardsParams = (params: UrlParams) => {
  const calculatedPageNum =
    isDefined(params?.pageNum) && !Number.isNaN(+(params?.pageNum as string))
      ? +(params?.pageNum as string)
      : DEFAULT_PAGE_NUM;
  const calculatedPageSize =
    isDefined(params?.pageSize) && !Number.isNaN(+(params?.pageSize as string))
      ? +(params?.pageSize as string)
      : DEFAULT_PAGE_SIZE;

  return {
    // _offset parameter should be passed not as an offset but rather as a page number
    _offset: String(calculatedPageNum),
    _limit: String(calculatedPageSize),
    _fromDate: params?.createdDateFrom,
    _toDate: params?.createdDateTo,
    _senderSharedId: params?.senderShareId,
    _recipientSharedId: params?.recipientShareId,
    _premoId: params?.premoId,
    _orderId: params?.orderId,
    _mPayReference: params?.mPayReference,
    ...(!isParameterAll(params?.status) && { _status: params?.status }),
    ...(!isParameterAll(params?.productId) && { _productId: params?.productId }),
  } as RequestParams;
};
